import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import { BsCheckCircleFill } from "react-icons/bs";
import { motion } from "framer-motion";

const Home = () => {
  const [steps, setSteps] = useState([false, false, false, false]);
  const navigate = useNavigate();

  const step = [
    "Choose Module",
    "Select Certification",
    "Attend Quiz",
    "Google Review",
    "Download Certificate",
  ];

  const handleModuleClick = (moduleId) => {
    setSteps((prevSteps) => {
      const newSteps = [...prevSteps];
      newSteps[0] = true;
      return newSteps;
    });

    navigate(`/module${moduleId}`, {
      state: { steps: [true, false, false, false] },
    });
  };

  const breadcrumbVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-shrink-0">
        <Navbar />
      </div>

      <div className="relative flex-grow px-4 py-8 md:px-12  bg-gradient-to-br from-red-100/90 via-white/70 to-red-100/90">
        {/* HEADER */}
        <div className="flex flex-col">
          <motion.h1
            className="text-center text-lg lg:text-3xl font-bold text-black"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 2, ease: "easeInOut" }}
          >
            Choose the Module below to take up Assessment
          </motion.h1>
        </div>

        {/* STEPPER */}
        <div className="flex justify-center mt-8 mb-6 px-2">
          <div className="flex items-center bg-white/70 backdrop-blur-md shadow-xl rounded-full p-2 flex-wrap gap-2">
            {step.map((stepLabel, index) => (
              <motion.div
                key={index}
                className="flex items-center"
                initial="initial"
                animate="animate"
                variants={breadcrumbVariants}
                transition={{ duration: 0.4, delay: index * 0.15 }}
              >
                <div
                  className={`flex items-center px-4 py-2 rounded-full text-xs sm:text-sm md:text-base font-medium transition-all duration-300
                  ${
                    steps[index]
                      ? "bg-green-500 text-white"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  <span
                    className={`mr-2 flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold
                    ${
                      steps[index]
                        ? "bg-white text-green-500"
                        : "bg-gray-300 text-gray-700"
                    }`}
                  >
                    {steps[index] ? <BsCheckCircleFill /> : index + 1}
                  </span>

                  {stepLabel}
                </div>

                {index < step.length - 1 && (
                  <div className="hidden md:block w-6 h-[2px] bg-gray-300 mx-1"></div>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        {/* MODULES */}
        <div className="grid grid-cols-1 mt-12 cursor-pointer md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
          {[
            {
              title: "Awareness Training",
              description:
                "Awareness training educates employees, stakeholders, and management teams about the principles, requirements, and benefits of ISO certifications.",
              onClick: () => handleModuleClick(1),
              number: 1,
            },
            {
              title: "Internal Auditor",
              description:
                "This module provides detailed information about the benefits and implementation of ISO certifications in various industries.",
              onClick: () => handleModuleClick(2),
              number: 2,
            },
            {
              title: "Lead Implementer",
              description:
                "This module provides detailed information about the benefits and implementation of ISO certifications in various industries.",
              onClick: () => handleModuleClick(3),
              number: 3,
            },
            {
              title: "Lead Auditor",
              description:
                "This module provides detailed information about auditing principles, processes, and techniques required to assess compliance and effectiveness of ISO management systems.",
              onClick: () => handleModuleClick(4),
              number: 4,
            },
          ].map((module, index) => (
            <div
              key={index}
              className={`relative bg-white/80 backdrop-blur-md rounded-2xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl
                ${index === 3 ? "lg:col-start-2" : ""}
                `}
            >
              {/* TOP BAR */}
              <div className="h-14 bg-gradient-to-r from-red-900 via-red-700 to-red-500"></div>

              {/* NUMBER */}
              <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-red-500 to-red-600 text-white border ring-4 ring-white rounded-full h-12 w-12 flex items-center justify-center font-bold text-xl shadow-md">
                {module.number}
              </div>

              <div className="p-6 pt-10 text-center">
                <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">
                  {module.title}
                </h2>

                <div className="bg-gray-100 rounded-xl p-4 shadow-inner mb-6">
                  <p className="text-sm md:text-base text-gray-600">
                    {module.description}
                  </p>
                </div>

                <button
                  onClick={module.onClick}
                  className="px-6 py-2 rounded-full font-semibold shadow-md transition bg-gradient-to-r from-red-700 via-red-600 to-red-500 text-white hover:scale-105"
                >
                  Start Module
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
